import React, { useState, useEffect } from 'react';
import {
  Container,
  Paper,
  Typography,
  Box,
  Alert,
  CircularProgress,
  Button
} from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import apiClient from '../../services/apiClient';
import logo from '../common/EchoNoteLogo.svg';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const verifyToken = searchParams.get('token');
    if (!verifyToken) {
      setStatus('error');
      setError('No verification token provided');
      return;
    }

    verifyEmail(verifyToken);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  const verifyEmail = async (verificationToken) => {
    try {
      const response = await apiClient.post('/auth/verify-email', {
        token: verificationToken
      });

      // Store the token
      if (response.data.token) {
        localStorage.setItem('token', response.data.token);
      }

      setStatus('success');
    } catch (err) {
      setStatus('error');
      setError(err.response?.data?.error || 'Verification failed. Please try again.');
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper elevation={3} sx={{ padding: 4, width: '100%' }}>
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
            <img 
              src={logo} 
              alt="EchoNote Logo" 
              style={{ width: '100px', height: '100px' }} 
            />
          </Box>
          
          {status === 'verifying' && (
            <>
              <Typography component="h1" variant="h5" align="center" gutterBottom>
                Verifying Your Email
              </Typography>
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                <CircularProgress />
              </Box>
            </>
          )}

          {status === 'success' && (
            <>
              <Typography component="h1" variant="h5" align="center" gutterBottom>
                Email Verified!
              </Typography>
              <Alert severity="success" sx={{ mt: 2, mb: 2 }}>
                Your email has been verified successfully. Your 60-minute free trial has started!
              </Alert>
              <Button
                fullWidth
                variant="contained"
                onClick={() => navigate('/dashboard')}
                sx={{ mt: 2 }}
              >
                Go to Dashboard
              </Button>
            </>
          )}

          {status === 'error' && (
            <>
              <Typography component="h1" variant="h5" align="center" gutterBottom>
                Verification Failed
              </Typography>
              <Alert severity="error" sx={{ mt: 2, mb: 2 }}>
                {error}
              </Alert>
              <Button
                fullWidth
                variant="outlined"
                onClick={() => navigate('/login')}
                sx={{ mt: 2 }}
              >
                Back to Login
              </Button>
            </>
          )}
        </Paper>
      </Box>
    </Container>
  );
};

export default VerifyEmail;
